import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ApiService } from 'src/app/_core/_services/api.service';

export interface AuditLogEntry {
  id: number;
  action_type: string;
  action_description: string;
  entity_type?: string;
  entity_id?: number;
  context?: string;
  ip_address?: string;
  user_agent?: string;
  source?: string;
  source_detail?: string;
  old_data?: any;
  new_data?: any;
  action_date: string;
  user_id?: number;
  actor_user_id?: number;
  tenant_id?: number;
  request_id?: string;
}

export interface AuditLogResponse {
  data: AuditLogEntry[];
  count: number;
  offset: number;
  limit: number;
}

@Injectable({
  providedIn: 'root'
})
export class AuditLogService {
  constructor(private api: ApiService) {}

  getAuditLogSummary(queryParams?: any) {
    if (queryParams) {
      queryParams = {
        ...queryParams
      };
    } else {
      queryParams = {
        limit: 10,
        offset: 0,
        q: '',
        filter: []
      };
    }

    return this.api.getAPI(`audit-logs`, queryParams).pipe(
      map((data: any) => {
        return data.body as AuditLogResponse;
      })
    );
  }

  getAuditLogs(queryParams?: any, filters?: Record<string, any>, contexts?: string[]) {
    // normal filters
    if (filters) {
      Object.keys(filters).forEach((key) => {
        const value = filters[key];
        if (value !== null && value !== undefined && value !== '') {
          queryParams[key] = value;
        }
      });
    }

    if (contexts && contexts.length > 0) {
      queryParams.context = contexts;
    }

    return this.api
      .getAPI('audit-logs', queryParams)
      .pipe(map((res: any) => res.body as AuditLogResponse));
  }
}
